<template>
  <div class="list">
    <loading v-if="isSearching" :message="'検索中...'"></loading>

    <template v-else-if="KoyouKeiyakuList && options">
      <h3>{{ KoyouKeiyakuList.length }}件ヒットしました。</h3>

      <table class="koyou-keiyaku-search-table"><!-- ToDo:勤務一覧のtableのスクロールを参照する -->
        <thead>
          <tr>
            <th class="id">雇用契約ID<br>（申請種別）</th>
            <th class="name">社員番号：<br>氏名（フリガナ）</th>
            <th class="syozoku" v-if="authStore.hasPermission(PermissionConst.KOYOUKEIYAKU_SEARCH_FOR_ALL)">所属
            </th>
            <th class="syuugyou-basyo">就業場所<br>（部課）</th>
            <th class="keitai">形態<br>種別</th>
            <th class="koyou-keitai">雇用<br>形態</th>
            <th class="kikan">契約<br>期間</th>
            <th class="syanai-syounin">社内<br>承認</th>
            <th class="honnin-syounin">本人<br>承認</th>
            <th class="kinmu-status">勤務<br>状況</th>
            <th class="notes">備考</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in KoyouKeiyakuList" :key="index"
            :class="{ 'deleted': row.is_sakujo, 'changed': row.is_changed }">
            <td>
              <span class="notice" v-if="row.is_sakujo">※削除済み※<br></span>
              <span class="notice" v-else-if="row.is_changed">※変更済み※<br></span>
              {{ row.koyou_keiyaku_id }}<br>[{{ getOptionsLabel(options.shinsei_type, row.shinsei_type) }}]</td>
            <!-- 契約書ID -->
            <td>
              <span class="staff-code" v-if="row.staff_code">{{ row.staff_code }}：<br></span>
              <router-link :to="{
                name: RouterConst.KOYOUKEIYAKU_DETAIL,
                params: {
                  id: row.koyou_keiyaku_id,
                },
              }">
                {{ row.name }}
                <span v-if="row.kana"><br>({{ row.kana }})</span>
              </router-link>
            </td><!-- 氏名 -->
            <td v-if="authStore.hasPermission(PermissionConst.KOYOUKEIYAKU_SEARCH_FOR_ALL)">{{
              getOptionsLabel(options.syozoku, row.syozoku_id) }}</td><!-- 所属 -->
            <td>{{ row.syuugyou_basyo }}<span v-if="row.buka"><br>（{{ row.buka }}）</span></td><!-- 就業場所 -->
            <td>{{ getOptionsLabel(options.keitai_type, row.keitai_type) }}</td><!-- 形態種別 -->
            <td>{{ getOptionsLabel(options.koyou_type, row.koyou_type) }}</td><!-- 雇用形態 -->
            <td>
              <span v-if="row.keiyaku_date">{{ row.keiyaku_date }}～<br></span>{{ row.koyou_end_date }}
            </td>
            <td>{{ getOptionsLabel(options.syounin_status_type, row.syounin_status_type) }}</td><!-- 申請種別 -->
            <td>{{ getOptionsLabel(options.honnin_status_type, row.honnin_status_type) }}</td><!-- 申請種別 -->
            <td>{{ getOptionsLabel(options.kinmu_status, row.kinmu_status) }}</td><!-- 勤務状況 -->
            <td>{{ row.syanai_notes != OptionConst.DEFAULT_NOTES_VALUE ? row.syanai_notes : '' }}</td><!-- 備考 -->
          </tr>
        </tbody>
      </table>
    </template>

    <template v-else-if="KoyouKeiyakuList?.length < 1">
      <h3>検索条件に合致するデータがありません。</h3>
    </template>
  </div>
</template>

<script lang="ts">

import { computed, defineComponent, onMounted, Ref } from 'vue'
import { RouterConst } from '@/const/Router';
import { SearchKoyouKeiyakuRes } from '@/types/KoyouKeiyaku';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';
import { useAuthStore } from '@/store/auth';
import { PermissionConst } from '@/const/Permission';
import OptionConst from '@/const/Option';

export default defineComponent({
  props: {
    KoyouKeiyakuList: {
      type: Object as () => SearchKoyouKeiyakuRes[],
      require: true,
      default: null
    },
    isSearching: {
      type: Boolean,
      require: true,
      default: false
    },
  },
  setup(props) {

    const { options, getAllKoyouKeiyakuOption, getOptionsLabel } = useKoyouKeiyakuInit();
    const authStore = useAuthStore()

    onMounted(async () => {
      await getAllKoyouKeiyakuOption()
    })

    return {
      RouterConst,
      options,
      getOptionsLabel,
      authStore,
      PermissionConst,
      OptionConst
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-search-list.scss';</style>
